import Skeleton from 'react-loading-skeleton';
import { useEffect, useState } from 'react';

function useResponsiveLayout() {
  const [config, setConfig] = useState({ items: 5, gap: 25, height: 430 });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const updateConfig = () => {
      const width = window.innerWidth;
      if (width < 350) setConfig({ items: 1.2, gap: 10, height: 300 });
      else if (width < 430) setConfig({ items: 1.7, gap: 10, height: 300 });
      else if (width < 716) setConfig({ items: 2.5, gap: 10, height: 300 });
      else if (width < 886) setConfig({ items: 3.5, gap: 11, height: 430 });
      else if (width < 1024) setConfig({ items: 4.5, gap: 12, height: 430 });
      else setConfig({ items: 4, gap: 25, height: 430 });
    };

    updateConfig();
    window.addEventListener('resize', updateConfig);
    return () => window.removeEventListener('resize', updateConfig);
  }, []);

  return config;
}

function IndexSkusCarouselSkeleton() {
  const { items, gap, height } = useResponsiveLayout();
  const itemCount = Math.ceil(items);
  const widthPercentage = `calc((100% - ${(itemCount - 1) * gap}px) / ${itemCount})`;

  return (
    <div>
      <div className="tw-flex tw-items-center tw-justify-between max-nine:tw-px-4 tw-pb-4">
        <div className="tw-w-[200px] max-nine:tw-w-[120px]">
          <Skeleton height={32} />
          <div className="tw-mt-1 tw-w-[80%]">
            <Skeleton height={5} />
          </div>
        </div>
        <div className="tw-w-[100px] max-nine:tw-w-[80px]">
          <Skeleton height={20} />
        </div>
      </div>

      <div className={`tw-w-full max-nine:tw-pl-4`} style={{ height }}>
        <div className="tw-flex" style={{ gap: `${gap}px` }}>
          {[...Array(itemCount)].map((_, index) => (
            <div
              key={index}
              className="tw-relative tw-border tw-border-solid tw-border-custom-gray tw-rounded-[20px] tw-p-4 tw-bg-white tw-shadow-md"
              style={{
                width: widthPercentage,
                minWidth: widthPercentage,
                height,
              }}
            >
              <div className="tw-absolute tw-top-3 tw-right-5">
                <Skeleton circle width={26} height={26} />
              </div>
              <div className="tw-w-full tw-mb-4">
                <div className="max-nine:tw-hidden">
                  <Skeleton height={271} width={'100%'} />
                </div>
                <div className="nine:tw-hidden">
                  <Skeleton height={130} width={'100%'} />
                </div>
              </div>
              <div className="tw-flex tw-flex-col tw-justify-between tw-gap-2">
                <Skeleton height={20} width={`80%`} />
                <Skeleton height={15} width={`60%`} />
                <div className="tw-flex tw-justify-between tw-items-center tw-mt-2">
                  <Skeleton height={25} width={60} />
                  <Skeleton height={20} width={20} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default IndexSkusCarouselSkeleton;
